import React from "react";
import * as API from "../lib/api";

export const useGetLocales = () => {
    const [list, setList] = React.useState({});

    React.useEffect(() => {
        API.Send("/lang/list").then(({ list }) => setList(list));
    }, []);

    return list;
};
